import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=593d3c6b&scoped=true&"
import script from "./ProductAdd.vue?vue&type=script&lang=js&"
export * from "./ProductAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductAdd.vue?vue&type=style&index=1&id=593d3c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593d3c6b",
  null
  
)

export default component.exports